import _ from 'lodash';
import {DEFAULT_STATE_VALUE,DEFAULT_KJ_QSKU,DEFAULT_KJ_QSKU2,DEFAULT_K_SKU,DEFAULT_K_SKU2,DEFAULT_Z_QSKU} from './constants';
import {sku2array} from './logic/sku-ver3.js'
import {
  get_default_sku
} from './reducers/utils';
// only this file exports two functions, which are the 'bridge' between the URL and app state:

// mapLocationToState takes location object and app state,
//   and returns new app state with location params merged into it

// mapStateToLocation takes app state and location,
//   and returns new location updated from app state

// functions necessary for parsing the URL parameters (eg. dates, numbers) can be implemented in here,
// or if more complicated, can be specified more rigidly somewhere else and called here



export function mapLocationToState(state, location) {
  //console.log('history URL>State',state,location)  
//  var state2={};
  switch(location.pathname) {
    
    case "/":
      let stateFromLocation = location.query;
    
     // state.initial_load=true
     state.loading = 'new'
         
     //console.log('DECODE START URL',stateFromLocation)
    
     let new_sku=get_default_sku()
     if (stateFromLocation === undefined || (['',DEFAULT_KJ_QSKU,DEFAULT_KJ_QSKU2,DEFAULT_Z_QSKU].includes(stateFromLocation['zalessku']) && stateFromLocation['sku'] === get_default_sku() && stateFromLocation['cfg'] === DEFAULT_STATE_VALUE
    ) ) {
     stateFromLocation['initial']='yes';
     stateFromLocation['initial-qsku']=stateFromLocation['zalessku']}
   // console.log('DECODE initial',stateFromLocation['initial'])
   //console.log('DECODE START URL1',stateFromLocation)
   if (stateFromLocation !== undefined && stateFromLocation['zalessku'] === DEFAULT_KJ_QSKU)
    {
      stateFromLocation['zalessku'] = ''
      stateFromLocation['sku'] = DEFAULT_K_SKU
      stateFromLocation['initial']='yes';
      stateFromLocation['initial-qsku']=DEFAULT_K_SKU
     }  
   if (stateFromLocation !== undefined && stateFromLocation['zalessku'] === DEFAULT_KJ_QSKU2)
  {
    stateFromLocation['zalessku'] = ''
    stateFromLocation['sku'] = DEFAULT_K_SKU2
    stateFromLocation['initial']='yes';
    stateFromLocation['initial-qsku']=DEFAULT_K_SKU2
}  
 //console.log('DECODE START URL2',stateFromLocation)
     if (stateFromLocation !== undefined) {
      if (!['true','false'].includes(stateFromLocation['isposterminal']) )
          stateFromLocation['isposterminal']= 'false'
      let new_sku2 =decodeURIComponent(stateFromLocation['sku']) 
      if (new_sku2 !== undefined && new_sku2 !== '') 
       new_sku =  new_sku2
     let allengr=['er','eb1','eb2']
      for (let i in allengr ) {
        if (stateFromLocation[allengr[i]] !=='') {
          stateFromLocation[allengr[i]] = decodeURIComponent(stateFromLocation[allengr[i]])
         }
       }
       let allud=['dct','dc','dcl','dl','dw','dd']
      for (let i in allud ) {

        if (stateFromLocation[allud[i]] !=='') {
          //console.log('adding',allud[i],stateFromLocation[allud[i]],'+')
          stateFromLocation[allud[i]] = decodeURIComponent(stateFromLocation[allud[i]])
         }
       }
       allengr=['fr','fb1']
       for (let i in allengr ) {
       //  if (["0","1"].indexOf(stateFromLocation[allengr[i]])  !== -1) {
       //    stateFromLocation[allengr[i]] = stateFromLocation[allengr[i]]
       //   }
       //   else
          stateFromLocation[allengr[i]] = '0'
        }
       
       }
      else {
        stateFromLocation ={'dct':'','dc':'','dcl':'','dl':'','dw':'','dd':'','er':'','eb1':'','eb2':'','fr':'0','fb1':'0','isposterminal':'false','ud':'D'} 
      }
     
     //dctw: '0.25',
    // console.log('load from url',state, stateFromLocation)
    if (stateFromLocation.zalessku ==='') {
     
    stateFromLocation['sku'] =  new_sku
     // console.log('from location.js 74',stateFromLocation.sku,stateFromLocation.zalessku)
     let refParam = sku2array(new_sku) 
     var list_extra=[]
     //if (stateFromLocation['zalessku'] ==='')
     for (let i1 in list_extra ){
       refParam[list_extra[i1]] =state[list_extra[i1]]
     }

     
     for (let i in refParam )
     {
      //console.log('param',i,refParam[i])
      stateFromLocation[i]= refParam[i]
     }
    }
     return _.merge({}, state, stateFromLocation);

    default:
      //console.log('default history')
      return state;
  }
}


// this is just a rough sketch of possible transformers.
// real ones could be much bigger or smarter,
// and could use schemas or constants files more effectively,
// but the point is having one location where this happens

export const paramSetup = {
  global: {
    action: {stateKey: 'action',  options: {shouldPush: true},initialState: 'redirect'},
    hs: {stateKey: 'hs',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    hc: {stateKey: 'hc',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    hu: {stateKey: 'hu',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    he: {stateKey: 'he',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    sku: {stateKey: 'sku',  options: {shouldPush: true},initialState: get_default_sku()},
    cfg: {stateKey: 'cfg',  options: {shouldPush: true},initialState: DEFAULT_STATE_VALUE},
    active_view: {stateKey: 'active_view',  options: {shouldPush: true},initialState: '1'},
    fr:  {stateKey: 'fr',  options: {shouldPush: true},initialState:  '0'},
    fb1:  {stateKey: 'fb1',  options: {shouldPush: true},initialState:  '0'},
    fb2:  {stateKey: 'fb2',  options: {shouldPush: true},initialState:  '0'},
    er: {stateKey: 'er',  options: {shouldPush: true},initialState: ''},
    eb1: {stateKey: 'eb1',  options: {shouldPush: true},initialState: ''},
    eb2: {stateKey: 'eb2',  options: {shouldPush: true},initialState: ''},
    dc: {stateKey: 'dc',  options: {shouldPush: true},initialState: ''},
    dcl: {stateKey: 'dcl',  options: {shouldPush: true},initialState: ''},
    dct: {stateKey: 'dct',  options: {shouldPush: true},initialState: ''},
    dl: {stateKey: 'dl',  options: {shouldPush: true},initialState: ''},
    dw: {stateKey: 'dw',  options: {shouldPush: true},initialState: ''},
    dd: {stateKey: 'dd',  options: {shouldPush: true},initialState: ''},
    zalessku: {stateKey: 'zalessku',  options: {shouldPush: true},initialState: ''},
    initial: {stateKey: 'initial',  options: {shouldPush: true},initialState: ''},
    isposterminal: {stateKey: 'isposterminal',  options: {shouldPush: true},initialState: 'false'}
   
    
  }
};


// WEBPACK FOOTER //
// ./src/location.js